export const saveToLS = (keyLS: string, value: any) => {
  // Get the existing localStorage content
  const lsData = window.localStorage.getItem(keyLS);

  let ls;

  if (lsData) {
    try {
      ls = JSON.parse(lsData);
    } catch {
      ls = lsData;
    }
  }

  // Update the value for the provided key
  ls = value;

  // Check if global.localStorage is available before attempting to set an item
  if (window.localStorage) {
    // Store the updated data back into localStorage
    window.localStorage.setItem(keyLS, JSON.stringify(ls));
  }
};

export const getFromLS = (keyLS: string) => {
  if (window.localStorage) {
    const lsData = window.localStorage.getItem(keyLS);
    if (lsData !== null) {
      try {
        return lsData ? JSON.parse(lsData) : {};
      } catch (e) {
        return lsData;
      }
    }
  }
};

export const removeLS = (keyLS: string) => {
  window.localStorage.removeItem(keyLS);
};
